var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapMarker = function SvgMapMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 30 30"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "map_marker_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 0h22v29.031H4Zm0 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#map_marker_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 0q-4.535 0-7.71 3.176-3.177 3.176-3.177 7.71 0 3.745 1.7 7.372 1.703 3.632 3.742 5.84 2.043 2.214 3.746 3.574L15 29.032c.3-.188.7-.473 1.191-.848.493-.38 1.36-1.184 2.61-2.41a30.6 30.6 0 0 0 3.289-3.801q1.417-1.959 2.605-4.989 1.194-3.033 1.192-6.097 0-4.536-3.176-7.711T15 0m0 12.703q-1.532 0-2.582-1.05t-1.047-2.579q0-1.534 1.047-2.582Q13.469 5.444 15 5.445q1.532 0 2.582 1.047 1.049 1.049 1.047 2.582 0 1.53-1.047 2.578-1.051 1.05-2.582 1.051m0 0"
  }))));
};
export default SvgMapMarker;